import React from "react";
import { PetAvatars } from "../../../components";
import { IPetDetail } from "../../../components/PetAvatars/PetAvatars";

interface IExpressPetQualifiesCard{
  petsName: string;
  locationName: string;
  eligiblePetsList: IPetDetail[];
}

const ExpressPetQualifiesCard = ({ petsName, locationName, eligiblePetsList }: IExpressPetQualifiesCard) => {
  return (
    <div className="w-full">
      <PetAvatars
        className="-mb-10 flex justify-center"
        height={85}
        width={85}
        maxVisible={3}
        petDetails={eligiblePetsList} />
      <div className="bg-white py-3 px-6 mx-2 rounded-xl pt-11">
        <div className="flex flex-col items-center gap-3 text-center">
          <div className="font-semibold text-xl">
            <div>
              <span>{petsName} </span>
              Now Qualifies for
            </div>
            <div>
              Express  Services
            </div>
          </div>
          <div className="font-semibold text-sm bg-taupe-15 px-4 py-1 w-[80%] rounded">
            at GoodVets{" "}
            <span className="capitalize">{locationName}*</span>
          </div>
          <div className="text-sm 2xl:px-7">
          Express Services offer quick, convenient technician led visits for routine pet care as directed by your Vet.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpressPetQualifiesCard;
